const USER_LEVEL = {
  ADMIN: "admin",
  OPERATOR: "operator",
  CLIENT: "client",
};
const CREATOR_LEVEL = {
  ENTRY: "entry",
  MARKETER: "marketer",
  PREMIUM: "premium",
};
Vue.prototype.CONSTANT = global.CONSTANT = {
  DIALOG_TYPE: {
    CREATIVE: "creative",
    CREATIVE_DETAIL: "creativeDetail",
    CREATIVE_FOLDER: "creativeFolder",
    ADVERTISER: "advertiser",
    CAMPAIGN: "campaign",
    DELETE: "delete",
    SELECT_FOLDER: "selectFolder",
    AUDIENCE: "audience",
    ASSET: "asset",
    SELECT_CREATIVE_TYPE: "selectCreativeType",
    SELECT_CREATIVE_TAG_TYPE: "selectCreativeTagType",
    CREATIVE_TEMPLATE: "creativeTemplate",
    USER_MANAGEMENT: "userManagement",
    USER_MANAGE_ADVERTISER_LIST: "userManageAdvertiserList",
    CREATE_USER: "createUser",
    CREATOR: "creator",
    CLONE: "clone"
  },
  MENU_TYPE: {
    CREATIVE_TABLE: "creativeTable",
    CREATIVE_FOLDER: "creativeFolder",
    ADVERTISER: "advertiser",
    CAMPAIGN: "campaign",
    AUDIENCE: "audience",
    ASSET: "asset",
    USER_MANAGEMENT: "userManagement",
    CREATE_USER: "createUser",
  },
  ENUM_CREATIVE_DISCRIMINATOR_KEY: {
    INSKIN: "inskin",
    PUSHDOWN: "pushdown",
    PARALLAX_SCROLLING: "parallaxScrolling",
    OUTSTREAM: "outstream",
    SCROLLINGBOX: "scrollingBox",
    CAROUSEL: "carousel",
    PUSHDOWN_WITH_OUTSTREAM: "pushdownWithOutstream",
    PARALLAX_SCROLLING_WITH_OUTSTREAM: "parallaxScrollingWithOutstream",
    PARALLAX_SCROLLING_FLIP: "parallaxScrollingFlip",
    BANNER: "banner",
    BANNER_WITH_OUTSTREAM: "bannerWithOutstream",
    SPINNER: "spinner",
    CARDS: "cards",
    ROLLING_CASTLE: "rollingCastle",
    SWITCH: "switch",
    MARQUEE: "marquee",
    ROTATINGFERRISWHELL: "rotatingFerrisWheel",
    SWAP: "swap",
    COUNT_DOWN: "countDown",
    VAST: "vast",
    POST_AD: "postAd",
    POST_AD_WITH_OUTSTREAM: "postAdWithOutstream",
    DATA_DRIVEN: "dataDriven",
  },
  ENUM_PREVIEW_TYPE: {
    HEADER: 0,
    FOOTER: 1,
    CONTENT: 2,
    LEFT_SIDE: 3,
    RIGHT_SIDE: 4,
    TOP_FIX: 5,
    BOTTOM_FIX: 6,
    INTERSTITIAL: 7,
  },
  PREVIEW_DEVICE: {
    PC: 0,
    MOBILE: 1,
  },
  MATERIAL_TYPE: {
    IMAGES: 0,
    HTML: 1,
  },
  CREATIVE_DEFAULT_VALUE: {
    INSKIN: {
      TOP_IMAGE: {
        MIN_HEIGHT: 400,
        MAX_HEIGHT: 600,
      },
      BOTTOM_IMAGE: {
        MIN_HEIGHT: 100,
        MAX_HEIGHT: 150,
      },
      CONTENT: {
        MIN_WIDTH: 60,
        MAX_WIDTH: 80,
      },
    },
    PARALLAX_SCROLLING: {
      MIN_NUM: 1,
      MAX_NUM: 5,
      ITEM: {
        material_type: 0,
        url: "",
        millisecond: 0,
        loop: true,
        times: 0,
      },
    },
    SCROLLINGBOX: {
      MIN_NUM: 2,
      MAX_NUM: 10,
      ITEM: {
        image_url: "",
        landing_page: "",
      },
    },
    CAROUSEL: {
      MIN_NUM: 5,
      MAX_NUM: 10,
      ITEM: {
        image_url: "",
        landing_page: "",
      },
    },
    SPINNER: {
      IMAGE: {
        MIN_NUM: 1,
        MAX_NUM: 2,
        ITEM: {
          url: "",
          use_shake_center: false,
          shake_center: { x: 0, y: 0 },
        },
      },
    },
    CARDS: {
      MIN_NUM: 4,
      MAX_NUM: 4,
      ITEM: {
        image_url: "",
        landing_page: "",
      },
    },
    ROLLING_CASTLE: {
      MIN_NUM: 5,
      MAX_NUM: 5,
      IMAGE: {
        MIN_NUM: 1,
        MAX_NUM: 2,
        ITEM: {
          BG: {
            type: "bg",
            url: "",
          },
          FG: {
            type: "fg",
            url: "",
            width: 100,
            is_float: false,
            vertical: { align: "center", padding: 0 },
            horizontal: { align: "center", padding: 0 },
          },
        },
      },
    },
    SWITCH: {
      MIN_NUM: 2,
      MAX_NUM: 4,
      ITEM: {
        image_url: "",
        landing_page: "",
      },
    },
    ROTATINGFERRISWHELL: {
      MIN_NUM: 3,
      MAX_NUM: 3,
      ITEM: {
        url: "",
      },
    },
    ROTATINGFERRISWHELL_STOP: {
      MIN_NUM: 1,
      MAX_NUM: 1,
      ITEM: {
        url: "",
      },
    },
    MARQUEE: {
      MIN_NUM: 3,
      MAX_NUM: 5,
      ITEM: {
        url: "",
      },
    },
    MARQUEE_STOP: {
      MIN_NUM: 1,
      MAX_NUM: 1,
      ITEM: {
        url: "",
      },
    },
    SWAP: {
      MIN_NUM: 2,
      MAX_NUM: 2,
      ITEM: {
        image_url: "",
        landing_page: "",
      },
    },
    COUNT_DOWN: {
      MIN_NUM: 3,
      MAX_NUM: 3,
      ITEM: {
        image_url: "",
      },
    },
    DATA_DRIVEN: {
      MIN_NUM: 1,
      MAX_NUM: 10,
      START_PAGE: 1,
      FINAL_PAGE: 2,
      PAGE_LENGTH: 2,
      ITEM: {
        name: "",
        landing_page: "",
        image_url: "",
        html_url: "",
        time_duration: null,
        time_duration_display: false,
        weather: "", // rainy, cloudy, sunny
        weather_display: false,
        humidity_min: null,
        humidity_max: null,
        humidity_display: false,
        temperature_min: null,
        temperature_max: null,
        temperature_display: false,
        temperature_unit: 0, // 0 = celsius, 1 = fahrenheit
        pm25_min: null,
        pm25_max: null,
        pm25_display: false,
        vertical: { align: "center", padding: 0 },
        horizontal: { align: "center", padding: 0 },
      },
    },
  },
  TEMPERATURE_TYPE: {
    C: 0,
    F: 1,
    K: 2,
  },
  USER_LEVEL,
  USER_LEVEL_FILTER: {
    ONLY_ADMIN: [USER_LEVEL.ADMIN],
    MID: [USER_LEVEL.ADMIN, USER_LEVEL.OPERATOR],
    ALL: [USER_LEVEL.ADMIN, USER_LEVEL.OPERATOR, USER_LEVEL.CLIENT],
  },
  STAGE_TYPE: {
    FRONT: "front",
    BACK: "back",
  },
  CREATOR_LEVEL,
  CREATOR_LEVEL_FILTER: {
    ENTRY: [CREATOR_LEVEL.ENTRY],
    MARKETER: [CREATOR_LEVEL.ENTRY, CREATOR_LEVEL.MARKETER],
    PREMIUM: [
      CREATOR_LEVEL.ENTRY,
      CREATOR_LEVEL.MARKETER,
      CREATOR_LEVEL.PREMIUM,
    ],
  },
  MARQUEE_TYPE: {
    TRADITION: 0,
    SPEED_CHANGE: 1,
    STOP: 2,
  },
  ROTATINGFERRISWHELL_TYPE: {
    TRADITION: 0,
    STOP: 1,
  }
};
